<div [class]="nonDefaultColor ? color : 'default'" (click)="onPress()">
    <p class="prevent-selection" [class]="{ bold: bold }">{{ label }}</p>
</div>